var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 0.333496C10.6866 0.333496 13.6666 3.3135 13.6666 7.00016C13.6666 10.6868 10.6866 13.6668 6.99992 13.6668C3.31325 13.6668 0.333252 10.6868 0.333252 7.00016C0.333252 3.3135 3.31325 0.333496 6.99992 0.333496ZM9.39325 3.66683L6.99992 6.06016L4.60659 3.66683L3.66659 4.60683L6.05992 7.00016L3.66659 9.3935L4.60659 10.3335L6.99992 7.94016L9.39325 10.3335L10.3333 9.3935L7.93992 7.00016L10.3333 4.60683L9.39325 3.66683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedCircle);
export default __webpack_public_path__ + "static/media/closed-circle.a44f277a433c6ad05ae84b797fc13d7c.svg";
export { ForwardRef as ReactComponent };